import React from 'react';
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import { useCollections } from '../hooks/useCollections';

export default function CollectionSelect({
  value,
  onChange,
  label = 'Коллекция',
  allowEmpty = false,
  emptyLabel = 'Все',
  required = false,
  fullWidth = true,
  includeInactive = false,
  multiple = false,
  helperText,
  margin,
}) {
  const { data: items = [] } = useCollections({ includeInactive });
  const selected = multiple ? value || [] : value;

  return (
    <FormControl fullWidth={fullWidth} required={required} margin={margin}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple={multiple}
        value={selected}
        label={label}
        onChange={onChange}
        renderValue={
          multiple
            ? (selectedCodes) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {(selectedCodes || []).map((code) => {
                    const item = items.find((collection) => collection.code === code);
                    return (
                      <Chip key={code} size="small" label={item ? item.name : code} />
                    );
                  })}
                </Box>
              )
            : undefined
        }
      >
        {allowEmpty && !multiple && <MenuItem value="">{emptyLabel}</MenuItem>}
        {items.map((collection) => (
          <MenuItem key={collection.code} value={collection.code}>
            {multiple && (
              <Checkbox checked={(selected || []).indexOf(collection.code) > -1} />
            )}
            <ListItemText primary={collection.name} secondary={collection.code} />
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
